import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DotBounceLoadingEffectComponent } from './dot-bounce-loading-effect.component';

@NgModule({
	declarations: [],
	imports: [DotBounceLoadingEffectComponent],
	exports: [DotBounceLoadingEffectComponent],
})
export class DotBounceLoadingEffectModule {}
